(function (app) {
    app.constant("rmeCampaignStartDate",
        {
            'year': 2018,
            'month': 0,
            'date': 1,
            'hour': 0,
            'minute': 0,
            'second': 0,
            'millisecond': 0
        });
})(window.app); //jshint ignore:line